/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "446")


  
    
export interface API48259Item {
  
  /**  */
  code?: number;
  
  /**  */
  desc?: string;
  
};
    
  



  export type API48259Req = {};



export interface API48259Res {
  /** T  */
  list?: API48259Item[];
  
};


// 48259 任务优先级枚举列表

export interface IUseGetAPI48259Return {
  /** 任务优先级枚举列表: 接口请求状态 */
  isAPI48259Loading: boolean;
  /** 任务优先级枚举列表: 接口请求返回数据 */
  dataAPI48259: API48259Res;
  /**  任务优先级枚举列表: 接口数据请求方法 */
  fetchAPI48259Data:  ( config?: YWRequestConfig) => Promise<API48259Res>;
  /** 任务优先级枚举列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48259 = ():IUseGetAPI48259Return => {
  let isMount = true;
  const [isAPI48259Loading, setIsAPI48259Loading] = useState(false);
  const [dataAPI48259, setDataAPI48259] = useState<API48259Res>({} as API48259Res);
  const requestUrl = `${basePath}/team-work/workTask/listTaskPriorityEnum`;

  const fetchAPI48259Data = async ( config?: YWRequestConfig): Promise<API48259Res> => {
  
    if ( isMount ) {
      setIsAPI48259Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48259Res>(`${basePath}/team-work/workTask/listTaskPriorityEnum`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48259(res || {} as API48259Res);
        setIsAPI48259Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48259Loading(false);
      }
      return false as unknown as API48259Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48259Loading,
    dataAPI48259,
    fetchAPI48259Data,
    requestUrl,
  }
}

